import req from "../../http";

const idl = {
  // 取得 面談背景資料
  getWorkedInfo(source, candidate) {
    if (source === "resume") {
      // 履歷
      return req("get", `/ResumeModule/IDL/GetWorkedInfo/${candidate}`);
    } else {
      // 人事資料表
      return req(
        "get",
        `/Recruitment/PersonnelInformation/IDL/GetWorkedInfo/${candidate}`
      );
    }
  },

  // 編輯 面談背景資料
  putWorkedInfo(source, params) {
    if (source === "resume") {
      // 履歷
      return req("put", "/ResumeModule/IDL/EditWorkedInfo", params);
    } else {
      // 人事資料表
      return req(
        "put",
        "/Recruitment/PersonnelInformation/IDL/EditWorkedInfo",
        params
      );
    }
  },

  // 取得 基本資料
  getBaseInfo(source, candidate) {
    if (source === "resume") {
      // 履歷
      return req("get", `/ResumeModule/IDL/GetBaseInfo/${candidate}`);
    } else {
      // 人事資料表
      return req(
        "get",
        `/Recruitment/PersonnelInformation/IDL/GetBaseInfo/${candidate}`
      );
    }
  },

  // 編輯 基本資料
  putBaseInfo(source, params) {
    if (source === "resume") {
      // 履歷
      return req("put", "/ResumeModule/IDL/EditBaseInfo", params);
    } else {
      // 人事資料表
      return req(
        "put",
        "/Recruitment/PersonnelInformation/IDL/EditBaseInfo",
        params
      );
    }
  },

  // 取得 學歷
  getEducation(source, candidate) {
    if (source === "resume") {
      // 履歷
      return req("get", `/ResumeModule/IDL/GetEducation/${candidate}`);
    } else {
      // 人事資料表
      return req(
        "get",
        `/Recruitment/PersonnelInformation/IDL/GetEducation/${candidate}`
      );
    }
  },

  // 編輯 學歷
  putEducation(source, params) {
    if (source === "resume") {
      // 履歷
      return req("put", "/ResumeModule/IDL/EditEducation", params);
    } else {
      // 人事資料表
      return req(
        "put",
        "/Recruitment/PersonnelInformation/IDL/EditEducation",
        params
      );
    }
  },

  // 取得 工作經歷
  getWorkExperience(source, candidate) {
    if (source === "resume") {
      // 履歷
      return req("get", `/ResumeModule/IDL/GetWorkExperience/${candidate}`);
    } else {
      // 人事資料表
      return req(
        "get",
        `/Recruitment/PersonnelInformation/IDL/GetWorkExperience/${candidate}`
      );
    }
  },

  // 編輯 工作經歷
  putWorkExperience(source, params) {
    if (source === "resume") {
      // 履歷
      return req("put", "/ResumeModule/IDL/EditWorkExperience", params);
    } else {
      // 人事資料表
      return req(
        "put",
        "/Recruitment/PersonnelInformation/IDL/EditWorkExperience",
        params
      );
    }
  },

  // 取得 專業技能
  getSkill(source, candidate) {
    if (source === "resume") {
      // 履歷
      return req("get", `/ResumeModule/IDL/GetSkill/${candidate}`);
    } else {
      // 人事資料表
      return req(
        "get",
        `/Recruitment/PersonnelInformation/IDL/GetSkill/${candidate}`
      );
    }
  },

  // 編輯 專業技能
  putSkill(source, params) {
    if (source === "resume") {
      // 履歷
      return req("put", "/ResumeModule/IDL/EditSkill", params);
    } else {
      // 人事資料表
      return req(
        "put",
        "/Recruitment/PersonnelInformation/IDL/EditSkill",
        params
      );
    }
  },

  // 取得 活動經驗
  getActivity(source, candidate) {
    if (source === "resume") {
      // 履歷
      return req("get", `/ResumeModule/IDL/GetActivityExperience/${candidate}`);
    } else {
      // 人事資料表
      return req(
        "get",
        `/Recruitment/PersonnelInformation/IDL/GetActivityExperience/${candidate}`
      );
    }
  },

  // 編輯 活動經驗
  putActivity(source, params) {
    if (source === "resume") {
      // 履歷
      return req("put", "/ResumeModule/IDL/EditActivityExperience", params);
    } else {
      // 人事資料表
      return req(
        "put",
        "/Recruitment/PersonnelInformation/IDL/EditActivityExperience",
        params
      );
    }
  },

  // 取得 語言能力
  getLanguage(source, candidate) {
    if (source === "resume") {
      // 履歷
      return req("get", `/ResumeModule/IDL/GetLanguage/${candidate}`);
    } else {
      // 人事資料表
      return req(
        "get",
        `/Recruitment/PersonnelInformation/IDL/GetLanguage/${candidate}`
      );
    }
  },

  // 編輯 語言能力
  putLanguage(source, params) {
    if (source === "resume") {
      // 履歷
      return req("put", "/ResumeModule/IDL/EditLanguage", params);
    } else {
      // 人事資料表
      return req(
        "put",
        "/Recruitment/PersonnelInformation/IDL/EditLanguage",
        params
      );
    }
  },

  // 取得 自傳
  getAutobiography(source, candidate) {
    if (source === "resume") {
      // 履歷
      return req("get", `/ResumeModule/IDL/GetAutobiography/${candidate}`);
    } else {
      // 人事資料表
      return req(
        "get",
        `/Recruitment/PersonnelInformation/IDL/GetAutobiography/${candidate}`
      );
    }
  },

  // 編輯 自傳
  putAutobiography(source, params) {
    if (source === "resume") {
      // 履歷
      return req("put", "/ResumeModule/IDL/EditAutobiography", params);
    } else {
      // 人事資料表
      return req(
        "put",
        "/Recruitment/PersonnelInformation/IDL/EditAutobiography",
        params
      );
    }
  },

  // 取得 工作配合
  getWorkCooperation(source, candidate) {
    if (source === "resume") {
      // 履歷
      return req("get", `/ResumeModule/IDL/GetWorkCooperation/${candidate}`);
    } else {
      // 人事資料表
      return req(
        "get",
        `/Recruitment/PersonnelInformation/IDL/GetWorkCooperation/${candidate}`
      );
    }
  },

  // 編輯 工作配合
  putWorkCooperation(source, params) {
    if (source === "resume") {
      // 履歷
      return req("put", "/ResumeModule/IDL/EditWorkCooperation", params);
    } else {
      // 人事資料表
      return req(
        "put",
        "/Recruitment/PersonnelInformation/IDL/EditWorkCooperation",
        params
      );
    }
  },

  // 取得 面試情況
  getInterviewInfo(source, candidate) {
    if (source === "resume") {
      // 履歷
      return req("get", `/ResumeModule/IDL/GetInterviewInfo/${candidate}`);
    } else {
      // 人事資料表
      return req(
        "get",
        `/Recruitment/PersonnelInformation/IDL/GetInterviewInfo/${candidate}`
      );
    }
  },

  // 編輯 面試情況
  putInterviewInfo(source, params) {
    if (source === "resume") {
      // 履歷
      return req("put", "/ResumeModule/IDL/EditInterviewInfo", params);
    } else {
      // 人事資料表
      return req(
        "put",
        "/Recruitment/PersonnelInformation/IDL/EditInterviewInfo",
        params
      );
    }
  },

  // 取得 職缺需求
  getWorkConsideration(source, candidate) {
    if (source === "resume") {
      // 履歷
      return req("get", `/ResumeModule/IDL/GetWorkConsideration/${candidate}`);
    } else {
      // 人事資料表
      return req(
        "get",
        `/Recruitment/PersonnelInformation/IDL/GetWorkConsideration/${candidate}`
      );
    }
  },

  // 編輯 職缺需求
  putWorkConsideration(source, params) {
    if (source === "resume") {
      // 履歷
      return req("put", "/ResumeModule/IDL/EditWorkConsideration", params);
    } else {
      // 人事資料表
      return req(
        "put",
        "/Recruitment/PersonnelInformation/IDL/EditWorkConsideration",
        params
      );
    }
  },

  // 取得 保密義務
  getNDA(source, candidate) {
    if (source === "resume") {
      // 履歷
      return req("get", `/ResumeModule/IDL/GetNDA/${candidate}`);
    } else {
      // 人事資料表
      return req(
        "get",
        `/Recruitment/PersonnelInformation/IDL/GetNDA/${candidate}`
      );
    }
  },

  // 編輯 保密義務
  putNDA(source, params) {
    if (source === "resume") {
      // 履歷
      return req("put", "/ResumeModule/IDL/EditNDA", params);
    } else {
      // 人事資料表
      return req(
        "put",
        "/Recruitment/PersonnelInformation/IDL/EditNDA",
        params
      );
    }
  },

  // 取得 競業禁止
  getNCC(source, candidate) {
    if (source === "resume") {
      // 履歷
      return req("get", `/ResumeModule/IDL/GetNCC/${candidate}`);
    } else {
      // 人事資料表
      return req(
        "get",
        `/Recruitment/PersonnelInformation/IDL/GetNCC/${candidate}`
      );
    }
  },

  // 編輯 競業禁止
  putNCC(source, params) {
    if (source === "resume") {
      // 履歷
      return req("put", "/ResumeModule/IDL/EditNCC", params);
    } else {
      // 人事資料表
      return req(
        "put",
        "/Recruitment/PersonnelInformation/IDL/EditNCC",
        params
      );
    }
  },

  // 取得 智財
  getIP(source, candidate) {
    if (source === "resume") {
      // 履歷
      return req("get", `/ResumeModule/IDL/GetIP/${candidate}`);
    } else {
      // 人事資料表
      return req(
        "get",
        `/Recruitment/PersonnelInformation/IDL/GetIP/${candidate}`
      );
    }
  },

  // 編輯 智財
  putIP(source, params) {
    if (source === "resume") {
      // 履歷
      return req("put", "/ResumeModule/IDL/EditIP", params);
    } else {
      // 人事資料表
      return req(
        "put",
        "/Recruitment/PersonnelInformation/IDL/EditIP",
        params
      );
    }
  },
};

export default idl;
